<template>
  <div v-if="dataReady" :id="id">
    <slot></slot>
  </div>
  <Spinner v-else></Spinner>
</template>

<script>
import Spinner from './spinner'
import appReady from 'CORE/utils/app-ready'

export default {
    name: 'DataReady',
    components: {
        Spinner,
    },
    props: {
        id: {
            type: String,
            required: false,
            default: _ => null,
        },
    },
    data() {
        return {
            dataReady: false,
        }
    },
    async mounted() {
        await appReady()
        this.dataReady = true
    },
}
</script>
